export default "__VITE_ASSET__ea15c0f2__"